import axios from 'axios';

// ⚠️ REPLACE WITH YOUR REAL IMGBB API KEY from https://api.imgbb.com/
const IMGBB_API_KEY = '26ba1bc18e54624a6b219ef12133e410';

export const uploadToImgBB = async (file) => {
  if (!file) return null;
  if (IMGBB_API_KEY === 'your_actual_imgbb_key_here') {
    console.error('⚠️ ImgBB API key not set! Get one from https://api.imgbb.com/');
    alert('Image upload requires API key. Contact admin.');
    return null;
  }
  
  const formData = new FormData();
  formData.append('image', file);
  formData.append('key', IMGBB_API_KEY);

  try {
    const response = await axios.post('https://api.imgbb.com/1/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 30000
    });

    if (response.data.success && response.data.data?.url) {
      return {
        url: response.data.data.url,
        name: file.name,
        size: file.size
      };
    }
    console.error('ImgBB Error:', response.data);
    return null;
  } catch (error) {
    console.error('Upload failed:', error.response?.data || error.message);
    alert('Upload failed: ' + (error.response?.data?.error?.message || error.message));
    return null;
  }
};

export const uploadMultipleToImgBB = async (files) => {
  if (!files?.length) return [];
  const results = await Promise.all(files.map(f => uploadToImgBB(f)));
  return results.filter(r => r !== null);
};
